import script from "./ReportPropertyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportPropertyModal.vue?vue&type=script&setup=true&lang=js"

import "./ReportPropertyModal.vue?vue&type=style&index=0&id=1537aa12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1537aa12"]])

export default __exports__